import * as dayjs from "dayjs";
import "dayjs/locale/en-gb";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

const dayjsExt = dayjs;

dayjs.locale("en");
dayjs.extend(updateLocale);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(relativeTime, {
  // Relative Time thresholds and rounding
  // https://day.js.org/docs/en/customization/relative-time#relative-time-thresholds-and-rounding
  thresholds: [
    { l: "s", r: 1 },
    { l: "ss", r: 59, d: "second" },
    { l: "m", r: 1 },
    { l: "mm", r: 59, d: "minute" },
    { l: "h", r: 1 },
    { l: "hh", r: 23, d: "hour" },
    { l: "d", r: 1 },
    { l: "dd", r: 29, d: "day" },
    { l: "M", r: 1 },
    { l: "MM", r: 11, d: "month" },
    { l: "y", r: 1 },
    { l: "yy", d: "year" },
  ],
});

dayjs.default.updateLocale("en", {
  relativeTime: {
    ...dayjs.Ls.en.relativeTime,
    s: "%d second",
    ss: "%d seconds",
    dd: function (dd: number) {
      // Custom handling since day.js doesn't support weeks in the relativeTime plugin by default
      if (dd >= 7) {
        const w = Math.round(dd / 7);
        return `${w} week${w > 1 ? "s" : ""}`;
      }
      return `${dd} days`;
    },
  },
});

export default dayjsExt;
